const focusItems = [
  {
    tag: '娱乐八卦',
    title: '2026暑期档影视大盘点：爆款与翻车齐飞',
    excerpt: '今年暑期档堪称神仙打架，从古装仙侠到现代悬疑，多部大制作轮番上阵。有的口碑爆棚圈粉无数，有的却因剧情注水被"吃瓜群众"集体吐槽。我们整理了最全观剧避雷指南，帮你精准吃瓜不踩坑。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20scene%20with%20warm%20coral%20and%20amber%20lighting%2C%20illustration%20style%20depicting%20film%20reels%20and%20drama%20elements%20floating%20in%20a%20dreamy%20composition%2C%20entertainment%20industry%20theme%2C%20soft%20artistic%20rendering%20with%20geometric%20abstract%20shapes%2C%20modern%20editorial%20look%20with%20warm%20peach%20background&width=800&height=500&seq=focus-1-2026&orientation=landscape',
    stat: '热议 128万',
    date: '2026-07-28',
  },
  {
    tag: '社会热点',
    title: '网红经济再起波澜：头部主播接连翻车引发行业反思',
    excerpt: '近期多位拥有千万粉丝的头部带货主播因产品质量问题和虚假宣传被曝光，引发全网讨论。从"全网最低价"到"退一赔三"承诺成空，吃瓜群众纷纷扒出更多行业内幕，平台监管力度或将迎来新一轮升级。',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20digital%20illustration%20of%20social%20media%20drama%20with%20warm%20amber%20and%20coral%20gradients%2C%20showing%20floating%20speech%20bubbles%20and%20notification%20icons%20around%20a%20central%20figure%2C%20modern%20flat%20design%20with%20soft%20shadows%2C%20online%20controversy%20theme%2C%20warm%20peach%20background%20with%20abstract%20flowing%20shapes&width=800&height=500&seq=focus-2-2026&orientation=landscape',
    stat: '热议 95万',
    date: '2026-07-27',
  },
  {
    tag: '科技财经',
    title: 'AI产品大战升级：各大厂新品密集发布谁能突围',
    excerpt: '2026年AI赛道竞争白热化，从智能助手到内容生成工具，各大厂商纷纷推出重磅产品。吃瓜群众围观各家发布会的同时，也在热议AI会不会取代更多工作岗位。业内人士深度分析各家产品的真实竞争力。',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20yet%20warm-toned%20abstract%20digital%20art%20showing%20interconnected%20nodes%20and%20data%20flow%20in%20coral%20and%20peach%20gradients%2C%20technology%20competition%20theme%2C%20soft%20geometric%20shapes%20floating%20in%20space%2C%20modern%20editorial%20style%20with%20clean%20lines%20and%20warm%20lighting%2C%20abstract%20composition&width=800&height=500&seq=focus-3-2026&orientation=landscape',
    stat: '热议 76万',
    date: '2026-07-26',
  },
  {
    tag: '体育电竞',
    title: '国际赛事精彩回顾：中国战队再创历史最佳战绩',
    excerpt: '在刚刚结束的国际电竞赛事中，中国战队以出色表现斩获多项大奖，刷新历史最好成绩。从小组赛的惊险出线到决赛的逆风翻盘，每一场对决都让吃瓜群众热血沸腾。赛后选手采访和幕后花絮同样精彩不断。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20esports-themed%20illustration%20with%20warm%20amber%20and%20coral%20accents%2C%20showing%20trophy%20silhouettes%20and%20victory%20elements%20in%20an%20artistic%20abstract%20style%2C%20gaming%20competition%20theme%2C%20soft%20modern%20flat%20design%20with%20flowing%20geometric%20shapes%2C%20warm%20peach%20background%20with%20subtle%20gradient&width=800&height=500&seq=focus-4-2026&orientation=landscape',
    stat: '热议 62万',
    date: '2026-07-25',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          精选全网最热话题，深度解读事件始末，不错过任何一个大瓜
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {focusItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-[200px] lg:w-[240px] h-[180px] sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                      {item.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center text-primary-400">
                        <i className="ri-fire-line"></i>
                      </span>
                      {item.stat}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}